import React from 'react';
import { getInitials, getAvatarColor, getTimeAgo, formatCommentDate } from '../../utils';
import {
    commentBlock,
    commentTopRow,
    commentAvatar,
    commentName,
    commentTime,
    commentActionBadge,
    commentText,
    commentMetaColumn,
    commentNameRow,
    commentDateText,
} from './CommentItem.style';
import { noDataText } from '../../RecentActivity.style';

const CommentItem = ({ comment, dateKey, avatarColors }) => {
    const byField = comment?.by;
    const name =
        typeof byField === 'object' && byField !== null ? byField?.name || '' : byField || '';
    const dateVal = comment?.[dateKey] || comment?.datetime || comment?.date || '';
    const action = comment?.action || '';

    return (
        <div style={commentBlock}>
            <div style={commentTopRow}>
                <div style={{ ...commentAvatar, backgroundColor: getAvatarColor(name, avatarColors) }}>
                    {getInitials(name)}
                </div>
                <div style={commentMetaColumn}>
                    <div style={commentNameRow}>
                        <span style={commentName}>{name}</span>
                        {action ? <span style={commentActionBadge}>{action}</span> : null}
                    </div>
                    <span style={commentDateText}>{formatCommentDate(dateVal)}</span>
                </div>
                <span style={commentTime}>{getTimeAgo(dateVal)}</span>
            </div>
            <div style={commentText}>{comment?.comment ?? comment?.text ?? ''}</div>
        </div>
    );
};

export const CommentList = ({ comments, dateKey, avatarColors, emptyMessage }) => {
    if (!comments || comments.length === 0) {
        return <div style={noDataText}>{emptyMessage || 'No comments to show'}</div>;
    }

    return comments.map((comment, index) => (
        <CommentItem
            key={`comment-${index}`}
            comment={comment}
            dateKey={dateKey}
            avatarColors={avatarColors}
        />
    ));
};

export default CommentItem;
